import logo from "../assets/images/logo.jpeg";
import securityImg from "../assets/images/contactusfooter.jpg";
import "../styles/footer.css";

export default function FooterSection() {
  return (
    <>
      {/* CTA */}
      <section className="contact-banner">
        <div className="contact-banner-container">

          {/* Use background-image — no more cropping issues */}
          <div
            className="contact-image"
            style={{
              backgroundImage: `url(${securityImg})`,
              backgroundSize: "cover",
              backgroundPosition: "center center",
              clipPath: "polygon(0 0, 90% 0, 100% 100%, 0% 100%)",
            }}
          />

          <div className="contact-content">
            <p>
              Whether you need professional security services or reliable
              facility management, COLIPS is here to support your business. We
              work closely with our clients to understand their needs and
              deliver practical solutions that make a real difference. Our
              experienced team is ready to provide dependable services you can
              trust. Get in touch with COLIPS today and let us help keep your
              premises safe and well managed.
            </p>
            <a href="/contact" className="contact-btn">
              CONTACT NOW
            </a>
          </div>
        </div>
      </section>

      {/* Upper Footer */}
      <section className="upper-footer">
        <div className="upper-footer-container">
          <div className="footer-col">
            <img src={logo} alt="COLIPS Logo" className="footer-logo" />
            <p>COLIPS Facilities Management</p>
          </div>

          <div className="footer-col">
            <h3>Contact</h3>
            <p><strong>Phone:</strong> 07459454530</p>
            <p><strong>Tel:</strong> 07438422831</p>
            <p>
              <strong>Email:</strong>{" "}
              <a href="mailto:info@colipsltd.com">
                info@colipsltd.com
              </a>
            </p>
          </div>

          <div className="footer-col">
            <h3>More Links</h3>
            <a href="/legal">Legal Notice</a>
            <a href="/privacy">Privacy Policy</a>
          </div>
        </div>
      </section>

      {/* Bottom Footer */}
      <footer className="footer-bottom">
        © 2026 COLIPS Facility Management
      </footer>
    </>
  );
}